
<template>
<div class="shell-page purchase-flow-page" :class="{ 'purchase-flow-page--checkout': step > 0 }">
<HeaderMain  v-show="!loadingEvent" @messageFromHeader="searchEvents"/>
<div>

</div>
<div>
       <SlideShow v-if="step===0"/>
       <SearchCourse v-if="!main" :courses="search" />

 <div :class="['purchase-flow-shell', { 'purchase-flow-shell--checkout': step > 0 }]">

    


    <section class="clean-block clean-product dark luxury-event-shell">
      
      
      <PreloaderComponent v-show="validateProc()===false"/>

      
      <div v-show="validateProc()===true" :class="['container shell-section event-view-shell', { 'event-view-shell--overview-mobile': step === 0 }]" style="padding-top: 40px; padding-bottom: 40px;">
        <div v-if="step>0" ref="checkoutStart" class="event-checkout-focus">
          <div class="event-checkout-focus__visual" :class="{ 'is-placeholder': !eventHeroImage }">
            <img v-if="eventHeroImage" :src="eventHeroImage" :alt="event.name" class="event-checkout-focus__visual-image" @error="shiftHeroImage">
            <div v-else class="event-checkout-focus__visual-placeholder">
              <span>{{ categorySpotlight.label }}</span>
              <strong>{{ event.name }}</strong>
            </div>

            <div class="event-checkout-focus__visual-overlay"></div>

            <div class="event-checkout-focus__visual-copy">
              <span class="event-checkout-focus__eyebrow">Checkout premium</span>
              <strong>{{ categorySpotlight.label }}</strong>
              <small>Paso {{ checkoutStage }} de 4</small>
            </div>
          </div>

          <div class="event-checkout-focus__main">
            <div class="event-checkout-focus__signals">
              <span class="event-checkout-focus__signal">{{ checkoutStageLabel }}</span>
              <span class="event-checkout-focus__signal event-checkout-focus__signal--muted">{{ checkoutAvailabilityLabel }}</span>
            </div>
            <h2 class="event-checkout-focus__title">{{ event.name }}</h2>
            <p class="event-checkout-focus__text">{{ checkoutStepCopy }}</p>

            <div class="event-checkout-focus__micro">
              <span><i class="far fa-clock"></i>{{ formatDate(event.start_date) }}</span>
              <span><i class="fas fa-map-marker-alt"></i>{{ venue.name }}{{ city ? '. ' + city : '' }}</span>
            </div>
          </div>

          <div class="event-checkout-focus__rail">
            <div class="event-checkout-focus__steps" aria-label="Pasos de compra">
              <article :class="['event-checkout-focus__step', { 'is-active': checkoutStage===1, 'is-done': checkoutStage>1 }]">
                <strong>1</strong>
                <span>Accesos</span>
              </article>
              <article :class="['event-checkout-focus__step', { 'is-active': checkoutStage===2, 'is-done': checkoutStage>2 }]">
                <strong>2</strong>
                <span>Datos</span>
              </article>
              <article :class="['event-checkout-focus__step', { 'is-active': checkoutStage===3, 'is-done': checkoutStage>3 }]">
                <strong>3</strong>
                <span>Cobertura</span>
              </article>
              <article :class="['event-checkout-focus__step', { 'is-active': checkoutStage===4, 'is-done': checkoutStage>4 }]">
                <strong>4</strong>
                <span>Pago</span>
              </article>
            </div>
          </div>
        </div>

        <div v-if="step===0" class="event-view-shell__overview">
        <div class="block-content luxury-panel luxury-panel--event" style="padding: 20px;">
          <div class="product-info container-fluid event-view">
            <div class="row event-view__layout">
              <div class="col-lg-6 event-view__media-column">
                <div class="gallery luxury-gallery event-view__gallery">
                  <div id="product-preview" class="vanilla-zoom">
                    <img v-if="eventHeroImage" :src="eventHeroImage" class="img-fluid" :alt="event.name" @error="shiftHeroImage">
                    <div v-else class="premium-card__placeholder event-view__media-placeholder">
                      <div class="premium-card__placeholder-mark">{{ event.name ? event.name.slice(0, 2).toUpperCase() : 'FP' }}</div>
                      <div class="premium-card__placeholder-copy">
                        <span class="premium-card__placeholder-kicker">Evento</span>
                        <strong>{{ event.name }}</strong>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="col-lg-6 event-view__content-column">
                <div class="info event-view__content">
                  <div class="event-view__eyebrow-row">
                    <span class="event-view__availability">{{ eventTickets.length !== 0 ? 'Disponible ahora' : 'Acceso con código' }}</span>
                  </div>

                  <h3 class="va-h4 event-view__title">{{event.name}}</h3>

                  <div ref="purchasePanel" class="event-view__purchase-box">
                    <p class="event-view__purchase-text">
                      {{ purchaseIntroCopy }}
                    </p>

                    <div class="event-view__purchase-actions">
                      <div v-if="eventTickets.length!=0" v-show="this.step==0" class="form-group event-view__cta-wrap">
                        <button @click="startSale()" class="event-view__cta event-view__serious-button event-view__action event-view__action--primary" type="button">
                          <span class="event-view__action-glow"></span>
                          <span class="event-view__action-clip">
                            <span class="event-view__action-ring"></span>
                          </span>
                          <span class="event-view__action-plate"></span>
                          <span class="event-view__action-inner">
                            <span class="event-view__action-copy">{{event_access}}</span>
                            <span class="event-view__action-icon"><i class="fas fa-ticket-alt"></i></span>
                          </span>
                        </button>
                      </div>

                      <button v-if="showPromoToggle" class="event-view__promo-toggle" type="button" @click="openPromoCode">
                        <i class="fas fa-key"></i>
                        <span>Tengo código</span>
                      </button>

                      <div v-if="showLockedState" class="shell-empty-state event-view__locked-state">
                        Este acceso requiere invitación o código.
                      </div>

                      <div class="form-group event-view__promo-group" v-if="showPromoPanel">
                        <div class="event-view__promo-header">
                          <p class="event-view__purchase-text event-view__purchase-text--promo">
                            Si tienes código, valídalo aquí.
                          </p>
                          <button v-if="canTogglePromoVisibility" class="event-view__promo-toggle event-view__promo-toggle--inline" type="button" @click="closePromoCode">
                            <i class="fas fa-times"></i>
                            <span>Ocultar</span>
                          </button>
                        </div>

                        <div class="searchcode event-view__promo-form">
                          <label class="event-view__promo-field" for="event-promo-code">
                            <span class="event-view__promo-field-icon"><i class="fas fa-tag"></i></span>
                            <input id="event-promo-code" ref="promoInput" type="text" v-model="promoCode" class="form-control event-view__promo-input" placeholder="Código de acceso" @keyup.enter="newEventTicketsSearch()" autocapitalize="characters" spellcheck="false">
                          </label>
                          <button @click="newEventTicketsSearch()" class="event-view__promo-apply event-view__serious-button event-view__action event-view__action--secondary" type="button" :disabled="promoLoading">
                            <span class="event-view__action-glow"></span>
                            <span class="event-view__action-ring"></span>
                            <span class="event-view__action-plate"></span>
                            <span class="event-view__action-inner">
                              <span class="event-view__action-copy">{{ promoLoading ? 'Validando...' : 'Validar' }}</span>
                              <span class="event-view__action-icon"><i class="fas fa-arrow-right"></i></span>
                            </span>
                          </button>
                        </div>

                        <h6 v-if="errCode" class="blog-category blog-text-success event-view__error">Código no encontrado o no disponible.</h6>
                      </div>
                    </div>
                  </div>

                  <div class="event-view__facts">
                    <article class="event-view__fact-card event-view__fact-card--venue">
                      <span class="event-view__fact-label">Venue</span>
                      <strong class="event-view__fact-value"><i class="fas fa-map-marker-alt"></i>{{venue.name}}. {{city}}</strong>
                    </article>

                    <div class="event-view__meta-chips">
                      <article class="event-view__meta-chip event-view__meta-chip--category" :class="`is-${categorySpotlight.key}`">
                        <div class="event-view__meta-chip-art" aria-hidden="true">
                          <svg v-if="categorySpotlight.key === 'concert'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <rect class="event-view__category-bar event-view__category-bar--a" x="24" y="68" width="8" height="14" rx="4" />
                            <rect class="event-view__category-bar event-view__category-bar--b" x="38" y="58" width="8" height="24" rx="4" />
                            <rect class="event-view__category-bar event-view__category-bar--c" x="52" y="48" width="8" height="34" rx="4" />
                            <rect class="event-view__category-mic-head" x="72" y="36" width="18" height="28" rx="9" />
                            <path class="event-view__category-mic-stem" d="M81 64V82" />
                            <path class="event-view__category-mic-base" d="M72 82H90" />
                            <path class="event-view__category-sound" d="M92 42C98 48 100 56 98 64" />
                            <path class="event-view__category-sound event-view__category-sound--alt" d="M98 36C106 46 108 58 104 70" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'party'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__party-burst" d="M66 32L72 16" />
                            <path class="event-view__party-burst event-view__party-burst--alt" d="M78 40L94 28" />
                            <path class="event-view__party-burst event-view__party-burst--soft" d="M84 54L102 54" />
                            <path class="event-view__party-ribbon" d="M48 48C60 34 76 30 96 36" />
                            <path class="event-view__party-ribbon event-view__party-ribbon--alt" d="M44 58C58 48 72 46 90 52" />
                            <path class="event-view__party-cone" d="M34 84L54 52L84 68L54 94Z" />
                            <path class="event-view__party-cone-band" d="M50 60L70 70" />
                            <rect class="event-view__party-confetti event-view__party-confetti--square" x="82" y="18" width="8" height="8" rx="2" />
                            <circle class="event-view__party-confetti event-view__party-confetti--dot" cx="96" cy="40" r="4" />
                            <circle class="event-view__party-confetti event-view__party-confetti--small" cx="74" cy="22" r="3" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'conference'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <rect class="event-view__category-screen" x="28" y="24" width="64" height="28" rx="12" />
                            <path class="event-view__category-screen-line" d="M42 36H76" />
                            <path class="event-view__category-screen-line" d="M42 44H66" />
                            <path class="event-view__category-podium" d="M48 68H72L78 92H42L48 68Z" />
                            <path class="event-view__category-podium-top" d="M56 60H64" />
                            <path class="event-view__category-mic-stem" d="M60 60V68" />
                            <circle class="event-view__category-attendee" cx="30" cy="86" r="5" />
                            <circle class="event-view__category-attendee" cx="90" cy="86" r="5" />
                            <path class="event-view__category-signal" d="M66 56C72 58 76 62 78 68" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'sport'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__category-track" d="M22 74C30 46 52 28 80 30C90 31 98 36 104 44" />
                            <path class="event-view__category-track event-view__category-track--alt" d="M18 86C28 58 52 40 82 42C92 43 100 48 106 56" />
                            <circle class="event-view__category-ball" cx="82" cy="38" r="8" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'theatre'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__category-stage" d="M28 86H92" />
                            <path class="event-view__category-spot" d="M60 22L76 54H44L60 22Z" />
                            <path class="event-view__category-curtain" d="M34 34C42 40 44 52 42 70C36 66 32 56 34 34Z" />
                            <path class="event-view__category-curtain" d="M86 34C78 40 76 52 78 70C84 66 88 56 86 34Z" />
                            <path class="event-view__category-curtain-line" d="M48 34V78" />
                            <path class="event-view__category-curtain-line" d="M72 34V78" />
                            <path class="event-view__category-arch event-view__category-arch--inner" d="M42 86C42 66 50 52 60 52C70 52 78 66 78 86" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'cinema'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <rect class="event-view__category-frame" x="28" y="34" width="64" height="44" rx="10" />
                            <path class="event-view__category-play" d="M54 46L74 56L54 66V46Z" />
                            <circle class="event-view__category-reel" cx="42" cy="34" r="6" />
                            <circle class="event-view__category-reel" cx="78" cy="34" r="6" />
                            <path class="event-view__category-perf" d="M36 42V70" />
                            <path class="event-view__category-perf" d="M84 42V70" />
                            <path class="event-view__category-screen-line" d="M44 86H76" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'culture'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__category-arch" d="M34 82C34 62 46 44 60 44C74 44 86 62 86 82" />
                            <path class="event-view__category-arch event-view__category-arch--inner" d="M44 82C44 68 52 56 60 56C68 56 76 68 76 82" />
                            <path class="event-view__category-beam" d="M60 30V88" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'food'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__category-cutlery" d="M44 24V54" />
                            <path class="event-view__category-cutlery" d="M38 24V40" />
                            <path class="event-view__category-cutlery" d="M50 24V40" />
                            <path class="event-view__category-cutlery event-view__category-cutlery--knife" d="M74 24V54" />
                            <circle class="event-view__category-plate" cx="60" cy="66" r="24" />
                            <circle class="event-view__category-plate event-view__category-plate--inner" cx="60" cy="66" r="12" />
                          </svg>

                          <svg v-else class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__category-drift" d="M28 66C38 48 52 40 70 42C82 44 92 50 98 60" />
                            <path class="event-view__category-drift event-view__category-drift--alt" d="M24 78C38 62 52 56 70 58C84 60 94 66 100 76" />
                            <circle class="event-view__category-core" cx="60" cy="60" r="10" />
                          </svg>
                        </div>

                        <div class="event-view__meta-chip-copy">
                          <span class="event-view__meta-chip-label">Categoría</span>
                          <strong class="event-view__meta-chip-value"><i :class="category.icon"></i>{{category.name}}</strong>
                        </div>
                      </article>

                      <article class="event-view__meta-chip event-view__meta-chip--date">
                        <div class="event-view__meta-chip-copy">
                          <span class="event-view__meta-chip-label">Fecha</span>
                          <strong class="event-view__meta-chip-value"><i class="far fa-clock"></i>{{formatDate(event.start_date)}}<span v-if="event.show_end_date==true"> - {{formatDate(event.end_date)}}</span></strong>
                        </div>
                      </article>
                    </div>
                  </div>

                  <div class="ftr" v-if="event.id==1">
                    <div class="alert alert-primary event-view__club-note" role="alert">
                      <strong class="event-view__star">★</strong> <strong>FOMOCLUB</strong> - Este evento cuenta con FOMOPLANES y sus socios para la producción y organización de la experiencia.
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="row event-view__overview-story">
              <div class="col-12">
                <div class="summary luxury-summary event-view__description-panel" ref="anchor1" id="anchor1">
                  <div class="event-view__description-header">
                    <span class="event-view__description-kicker">Descripción</span>
                  </div>

                  <div class="event-view__description-body">
                    <p v-for="(paragraph, index) in eventDescriptionParagraphs" :key="`event-description-${index}`" class="event-view__description">
                      {{ paragraph }}
                    </p>

                    <p v-if="!eventDescriptionParagraphs.length" class="event-view__description event-view__description--empty">
                      Este evento todavía no tiene descripción publicada.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>

        <Teleport to="body">
          <div v-if="step === 0" class="event-view__mobile-assist" aria-live="polite">
            <div class="event-view__mobile-assist-card">
              <div class="event-view__mobile-assist-copy">
                <span>{{ mobileAssistKicker }}</span>
                <strong>{{ mobileAssistHeadline }}</strong>
                <small>{{ mobileAssistText }}</small>
              </div>

              <div class="event-view__mobile-assist-actions">
                <button @click="handleMobileAssistPrimary()" class="event-view__mobile-assist-primary" type="button">
                  <i :class="mobileAssistPrimaryIcon"></i>
                  <span>{{ mobileAssistPrimaryLabel }}</span>
                </button>

                <button v-if="mobileAssistHasSecondary" @click="focusPromoCode()" class="event-view__mobile-assist-secondary" type="button" aria-label="Ir a código de acceso">
                  <i class="fas fa-key"></i>
                </button>
              </div>
            </div>
          </div>
        </Teleport>

                    

                    <section >
                   
                    <div  id="detailpre" v-if="step==0" class="product-info" style="padding-top: 20px;">
                         <EventViewDetail :updatesProp="updates" :eventTickets="eventTickets" :eventType="event.access"/>  
                    </div>

                    <div v-if="step==1" class="product-info" style="padding-top: 20px;">
                        
                         <SaleQuantity  @messageFromCart="startUserCreation" :eventTickets="eventTickets" :coordinated_fee="event.coordinated_fee" :coordinated_service="event.coordinated_service" :fixed_fee="event.fixed_fee" :paymentOptions="event.payment_options || []"/>  

                    </div>




                    <template v-if="step==5">
  <VaButton style="margin: 20px;" @click="showModal = !showModal">
    Abrir mapa
  </VaButton>

  <VaModal
    v-model="showModal"
    overlay-opacity="0.2"
    no-outside-dismiss
    fullscreen
    backgroundColor	="rgb(10,2,49)"

    

  >

  <h3 class="va-h3">
      Selección de Asientos
    </h3>


  <div v-for="(product, index)  in seatsProducts" :key="index ">
                          <VenueMap  @messagefromVenueMap="startUserCreation1" v-if="index==mapValidator" :id="product.id" :quantityM="product.quantity_factor*product.quantity"/>  
                        </div>
  </VaModal>
</template>
                       
      


                  

                     <div v-if="step==2 " class="product-info" style="padding-top: 20px;">
                      <GuestNameBar v-if="event.access==5" @messageFromGuestName="startFinalSale" :event="event" :productsProp="products" :order_finalF="order_total" :selectedSeats="selectedSeats" :seatsProducts="seatsProducts"/>  
                         
                      <GuestName v-if="event.access!=5" @messageFromGuestName="startFinalSale" :event="event" :productsProp="products" :order_finalF="order_total" :selectedSeats="selectedSeats" :seatsProducts="seatsProducts"/>  
                         
                     </div>


                     <div v-if="step==6" class="product-info" style="padding-top: 20px;">
                         <FomoSafeStep
                           @messageFromAddons="startPaymentStep"
                           :ticketsTable="ticketsTable"
                           :subtotal="order_subtotal"
                           :fee="order_fee"
                           :total="order_base_total"
                         />
                     </div>


                     <div v-if="step==3" class="product-info" style="padding-top: 20px;">
                         <CustomerData @messageFromCustomerData="completeSale" :ticketsTable="ticketsTable" :totalProp="order_total" :subtotalProp="order_subtotal" :feeProp="order_fee" :addonsTotalProp="order_addons_total" :addonsProp="selectedAddons" :posProp="event.pos" :customer_prop="customer"  :event="event" :code="code"/>  
                     </div>

                    <div v-if="step==4 && saleResult==1" class="product-info" style="padding-top: 20px;">
                      <p>Fomo plan activado. Tus accesos han sido enviados al correo registrado y puedes obtenerlos desde la opción <strong>Mis Planes</strong></p>
                    </div>

                    <div v-if="step==4 && saleResult==2" class="product-info" style="padding-top: 20px;">
                      <p>Fomo plan activado. Tus accesos han sido enviados al correo registrado y puedes obtenerlos desde la opción <strong>Mis Planes</strong></p>
                    </div>

                  </section>              
                    
                    <div class="clean-related-items"></div>
      </div>
  </section>




 </div>

    <footer v-show="!loadingEvent">
        <FooterMain/>
    </footer>


</div>
</div>

</template>

<script>
// @ is an alias to /src
import { apiService, apiServiceSession } from "../common/api.services.js";

import HeaderMain from "@/components/HeaderMain.vue"
import FooterMain from "@/components/FooterMain.vue";
import EventViewDetail from "@/components/EventViewDetail.vue";
import SlideShow from "@/components/SlideShow.vue";
import SearchCourse from "@/components/SearchCourse.vue";
import baguetteBox from "../../node_modules/baguettebox.js"
import SaleQuantity from "@/components/sales/SaleQuantity.vue"
import CustomerData from "@/components/sales/CustomerData.vue"
import GuestName from "@/components/sales/GuestName.vue"
import GuestNameBar from "@/components/sales/GuestNameBar.vue"
import FomoSafeStep from "@/components/sales/FomoSafeStep.vue"
import VenueMap from "@/components/sales/VenueMap.vue"
import PreloaderComponent from "@/components/PreloaderComponent.vue"


export default {
  name: "EventView",

   props: {

    slug: {
      required: true
    },
    

    //log25
    
  },

 


  data(){
    return{
      search:[],
      searchField:"",
      main: true,
      err: false,
      requestUserStatus: false,
      requestUserType: false,
      showLoading: false,
      event: {},
      venue: {},
      category: {},
      city: "",
      eventTickets: [],
      defaultEventTickets: [],
      updates: [],
      host: null,
      code: null,
      next: null,
      errCode: false,
      promoCode: "",
      saleMode: false,
      order_fee: 0,
      order_addons_total: 0,
      order_base_total: 0,
      order_total:0,
      products:0,
      step: 0,
      name: "",
      last_name: "",
      phone: "",
      email: "",
      cc: "",
      ticketsTable: [],
      order_subtotal: 0,
      wanted: false,
      saleResult: 0,
      auto_sale: false,
      id: null,
      main_fn:"",
      main_ln:"",
      main_ph:"",
      customer: {},
      selectedAddons: [],
      map: false,
      selectedSeats: [],
      seatsProducts: [],
      mapValidator: 0,
      mapLenght: 0,
      showCode: false,
      promoLoading: false,
      loadingEvent: false,
      event_access: "Comprar Tickets",
      showModal: true,
      pixelId: null,
      scriptLoaded: false,
      eventImageIndex: 0,
      ticketRequestVersion: 0,
      suppressPromoRouteWatcher: false,

      

    };
  },
  components: {
    HeaderMain,
    FooterMain,
    SlideShow,
    SearchCourse,
    EventViewDetail,
    SaleQuantity,
    CustomerData,
    GuestName,
    FomoSafeStep,
    VenueMap,
    PreloaderComponent,
    GuestNameBar
  

  },

  computed: {
    eventImageCandidates() {
      return [this.event.banner_url, this.event.image_url, this.event.cover_url, this.event.thumbnail]
        .filter(Boolean)
        .flatMap((value) => this.resolveMediaCandidates(value))
    },

    eventHeroImage() {
      return this.eventImageCandidates[this.eventImageIndex] || ''
    },

    eventDescriptionParagraphs() {
      return String(this.event.description || '')
        .split(/\n+/)
        .map((paragraph) => paragraph.trim())
        .filter(Boolean)
    },

    categorySpotlight() {
      const source = `${this.category.name || ''} ${this.category.icon || ''}`.toLowerCase()

      if (/(concert|concierto|recital|live|show|band|banda)/.test(source)) {
        return {
          key: 'concert',
          label: 'Concierto',
        }
      }

      if (/(party|fiesta|club|dj|rave|night|after|festival)/.test(source)) {
        return {
          key: 'party',
          label: 'Fiesta',
        }
      }

      if (/(conference|conferencia|summit|forum|expo|congreso|business|network|tech|startup)/.test(source)) {
        return {
          key: 'conference',
          label: 'Conferencia',
        }
      }

      if (/(sport|deport|futbol|football|run|running|tenis|tennis|golf|padel|fitness|match)/.test(source)) {
        return {
          key: 'sport',
          label: 'Deporte',
        }
      }

      if (/(theatre|teatro|obra|musical|drama|stage)/.test(source)) {
        return {
          key: 'theatre',
          label: 'Teatro',
        }
      }

      if (/(cine|film|cinema|movie|pelicula|screening)/.test(source)) {
        return {
          key: 'cinema',
          label: 'Cine',
        }
      }

      if (/(art|arte|cultur|gallery|galeria|museum|museo)/.test(source)) {
        return {
          key: 'culture',
          label: 'Cultura',
        }
      }

      if (/(food|drink|gastro|brunch|dinner|wine|cocktail|chef|restaurant|restaurante)/.test(source)) {
        return {
          key: 'food',
          label: 'Gastronomia',
        }
      }

      return {
        key: 'default',
        label: 'Evento',
      }
    },

    checkoutStage() {
      if (this.step === 3) {
        return 4
      }

      if (this.step === 6) {
        return 3
      }

      if (this.step === 2 || this.step === 5) {
        return 2
      }

      if (this.step >= 1) {
        return 1
      }

      return 0
    },

    checkoutStepCopy() {
      if (this.step === 1) {
        return 'Elige tus accesos y revisa el subtotal antes de continuar con los datos del comprador.'
      }

      if (this.step === 2 || this.step === 5) {
        return 'Completa datos en un entorno limpio, suave y rápido para no romper el deseo de compra.'
      }

      if (this.step === 6) {
        return 'Activa en segundos una capa adicional para proteger el valor elegible de tu compra ante imprevistos personales validables.'
      }

      if (this.step === 3) {
        return 'Cierra con un total impecable, métodos claros y una última sensación premium antes del acceso.'
      }

      return 'Compra activa y lista para avanzar.'
    },

    checkoutStageLabel() {
      if (this.checkoutStage === 1) {
        return 'Selección de accesos'
      }

      if (this.checkoutStage === 2) {
        return 'Datos del comprador'
      }

      if (this.checkoutStage === 3) {
        return 'Cobertura FOMO'
      }

      if (this.checkoutStage === 4) {
        return 'Pago y cierre'
      }

      return 'Compra activa'
    },

    checkoutAvailabilityLabel() {
      if (this.event.access === 1 && this.eventTickets.length !== 0) {
        return 'Compra abierta'
      }

      if (this.event.access === 1) {
        return 'Venta en preparación'
      }

      return 'Acceso con código'
    },

    purchaseIntroCopy() {
      if (this.event.access === 1) {
        return 'Compra activa ahora. Si tienes código, puedes validarlo.'
      }

      return 'Acceso reservado con invitación o código.'
    },

    canTogglePromoVisibility() {
      return this.step === 0 && this.event.access === 1
    },

    showPromoToggle() {
      return this.canTogglePromoVisibility && !this.showPromoPanel
    },

    showLockedState() {
      return this.step === 0 && this.event.access !== 1 && this.eventTickets.length === 0
    },

    showPromoPanel() {
      if (this.step !== 0) {
        return false
      }

      if (this.event.access !== 1) {
        return true
      }

      return this.showCode || this.errCode || this.promoLoading
    },

    mobileAssistKicker() {
      return this.eventTickets.length !== 0 ? 'Compra rapida' : 'Acceso guiado'
    },

    mobileAssistHeadline() {
      return this.eventTickets.length !== 0 ? 'No pierdas la compra' : 'Valida tu código'
    },

    mobileAssistText() {
      return this.eventTickets.length !== 0
        ? 'Te llevo directo a seleccionar accesos.'
        : 'Abro el campo para validar tu código.'
    },

    mobileAssistPrimaryLabel() {
      return this.eventTickets.length !== 0 ? 'Comprar ahora' : 'Validar código'
    },

    mobileAssistPrimaryIcon() {
      return this.eventTickets.length !== 0 ? 'fas fa-ticket-alt' : 'fas fa-key'
    },

    mobileAssistHasSecondary() {
      return this.showLockedState
    },
  },

  watch: {
    step(newStep, oldStep) {
      if (newStep === oldStep || newStep === 0) {
        return
      }

      this.$nextTick(() => {
        const checkoutTarget = this.$refs['checkoutStart'] || this.$refs['anchor1']

        if (checkoutTarget && checkoutTarget.scrollIntoView) {
          checkoutTarget.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    },

    '$route.query.co'(nextCode, previousCode) {
      if (nextCode === previousCode || !this.id) {
        return
      }

      if (this.suppressPromoRouteWatcher) {
        this.suppressPromoRouteWatcher = false
        return
      }

      this.getEventTickets()
    },

    '$route.params.slug'(nextSlug, previousSlug) {
      if (nextSlug === previousSlug) {
        return
      }

      this.getEvent()
    },
  },

  mounted() {
    //require('../assets/js/theme.js')
// Custom theme code


var vanillaZoom = {};
        vanillaZoom.init = function(el) {

            var container = document.querySelector(el);
            if(!container) {
                console.error('No container element. Please make sure you are using the right markup.');
                return;
            }

            var firstSmallImage = container.querySelector('.small-preview');
            var zoomedImage = container.querySelector('.zoomed-image');

            if(!zoomedImage) {
                console.error('No zoomed image element. Please make sure you are using the right markup.');
                return;
            }

            if(!firstSmallImage) {
                console.error('No preview images on page. Please make sure you are using the right markup.');
                return;
            }
            else {
                // Set the source of the zoomed image.
                zoomedImage.style.backgroundImage = 'url('+ firstSmallImage.src +')';
                firstSmallImage.classList.add('active');
            }   

            // Change the selected image to be zoomed when clicking on the previews.
            container.addEventListener("click", function (event) {
                var elem = event.target;

                if (elem.classList.contains("small-preview")) {
                    
                    var allSmallPreviews = container.querySelectorAll(".small-preview");
                    
                    allSmallPreviews.forEach(function (preview) {
                        preview.classList.remove('active');
                    })
                    
                    elem.classList.add('active');
                    
                    var imageSrc = elem.src;
                    zoomedImage.style.backgroundImage = 'url('+ imageSrc +')';
                }
            });
            
            // Zoom image on mouse enter.
            zoomedImage.addEventListener('mouseenter', function(e) {
                this.style.backgroundSize = "250%"; 
                console.log(e)
            }, false);


            // Show different parts of image depending on cursor position.
            zoomedImage.addEventListener('mousemove', function(e) {
                
                // getBoundingClientReact gives us various information about the position of the element.
                var dimentions = this.getBoundingClientRect();

                // Calculate the position of the cursor inside the element (in pixels).
                var x = e.clientX - dimentions.left;
                var y = e.clientY - dimentions.top;

                // Calculate the position of the cursor as a percentage of the total width/height of the element.
                var xpercent = Math.round(100 / (dimentions.width / x));
                var ypercent = Math.round(100 / (dimentions.height / y));

                // Update the background position of the image.
                this.style.backgroundPosition = xpercent+'% ' + ypercent+'%';
            
            }, false);


            // When leaving the container zoom out the image back to normal size.
            zoomedImage.addEventListener('mouseleave', function(e) {
                console.log(e)
                this.style.backgroundSize = "contain"; 
                this.style.backgroundPosition = "left center"; 
            }, false);

        }


if (document.getElementsByClassName('clean-gallery').length > 0) {
   baguetteBox.run('.clean-gallery', { animation: 'slideIn' });
}

if (document.getElementsByClassName('clean-product').length > 0) {
    window.onload = function() {
        vanillaZoom.init('#product-preview');
    };
}

    },

  created(){
    
   

    this.getEvent()




  },
  methods:{
      normalizePromoCodeValue(value) {
      return String(value || '').trim().toUpperCase()
    },

      syncPromoRoute(codeValue, wanted = null) {
      const nextQuery = { ...this.$route.query }
      const normalizedCode = this.normalizePromoCodeValue(codeValue)
      const currentCode = this.normalizePromoCodeValue(this.$route.query.co)
      const currentWanted = this.$route.query.wanted === 'true'

      if (normalizedCode) {
        nextQuery.co = normalizedCode
      } else {
        delete nextQuery.co
      }

      if (wanted === true) {
        nextQuery.wanted = 'true'
      } else if (wanted === false) {
        delete nextQuery.wanted
      }

      const nextWanted = nextQuery.wanted === 'true'
      const routeWouldChange = currentCode !== normalizedCode || currentWanted !== nextWanted

      if (!routeWouldChange) {
        this.suppressPromoRouteWatcher = false
        return Promise.resolve()
      }

      return this.$router.replace({ name: 'event', params: { slug: this.slug }, query: nextQuery }).catch(() => {})
    },

      openPromoCode() {
      this.showCode = true
      this.errCode = false
    },

      closePromoCode() {
      this.showCode = false
      this.errCode = false
      this.promoCode = ""
      this.promoLoading = false
      this.code = null
      this.syncPromoRoute('', false)
      this.eventTickets = [...this.defaultEventTickets]
    },

      normalizeTicketsResponse(data) {
      if (Array.isArray(data)) {
        return data
      }

      if (data && Array.isArray(data.results)) {
        return data.results
      }

      return []
    },

      resolveMediaCandidates(value) {
      if (!value) {
        return []
      }

      const origin = window.location.origin
      const localBackendCandidates = ['http://127.0.0.1:8000', 'http://localhost:8000']
      const normalizePath = (candidate) => candidate
        .replace(/^\/media\//, '')
        .replace(/^.*\/media\//, '')
        .replace(/^media\//, '')
        .replace(/^\//, '')

      if (value.startsWith('data:') || value.startsWith('blob:')) {
        return [value]
      }

      if (/^https?:\/\//i.test(value)) {
        try {
          const parsed = new URL(value)

          if (!parsed.pathname.includes('/media/')) {
            return [value]
          }

          const normalizedPath = normalizePath(parsed.pathname)

          return [...new Set([
            value,
            `${origin}/media/${normalizedPath}`,
            ...localBackendCandidates.map((base) => `${base}/media/${normalizedPath}`),
            `https://gingopolisdjango.blob.core.windows.net/fomoapp/media/${normalizedPath}`,
          ])]
        } catch (error) {
          return [value]
        }
      }

      const normalizedPath = normalizePath(value)

      if (value.startsWith('/media/') || value.startsWith('media/') || !value.startsWith('/')) {
        return [...new Set([
          `${origin}/media/${normalizedPath}`,
          ...localBackendCandidates.map((base) => `${base}/media/${normalizedPath}`),
          `https://gingopolisdjango.blob.core.windows.net/fomoapp/media/${normalizedPath}`,
        ])]
      }

      return [`${origin}${value}`]
    },

      shiftHeroImage() {
      if (this.eventImageIndex < this.eventImageCandidates.length - 1) {
        this.eventImageIndex += 1
      } else {
        this.eventImageIndex = this.eventImageCandidates.length
      }
    },

      getEvent() {
      this.wanted = this.$route.query.wanted



      
      this.loadingEvent=true
      // make a GET Request to the questions list endpoint and populate the questions array


      let endpoint = `/api/events/${this.slug}/`;

      console.log(this.slug)

      if (this.slug=="PSYCHO-LAB-HORROR-NIGNT"  ){
        endpoint = `/api/events/PSYCHO-LAB-HORROR-NIGHT/`;
      }

      


      this.showLoading = true;
      apiService(endpoint).then((data) => {
        this.event = data;
        this.eventImageIndex = 0

        //funciona solo MULALO 2 DIC 23
        if (this.event.id==90){
          window.location.href = "/event/Tambo/";
        }

        //Aplica solo PGA
        if (this.event.id==411){
          this.event_access="Reservar Tickets"
        }

        if (this.event.access!=1){
          this.showCode=true

        }
        this.id=data.id
        this.category = data.category
        this.venue = data.venue
        this.city = data.venue.city.name
        this.showLoading = false;
        this.updates = data.updates
        this.event_id = data.id
        
        if(data.meta_pixel!=""){
          this.pixelId=data.meta_pixel
        }

        this.recordLandingVisit()

        this.getEventTickets()
        if (data.access==6){
          this.event_access="Aplicar a Grupo"
        }
        

      });
      

     
    },

    
    loadMetaPixel() {
      if (this.pixelId) {
        console.log("oasi");
        (function(f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function() {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        window.fbq('init', this.pixelId);
        window.fbq('track', 'PageView');
      }
    },


    startSale(){

      this.saleMode=true
      this.step=1
      this.$nextTick(() => {
        const checkoutTarget = this.$refs['checkoutStart'] || this.$refs['anchor1']

        if (checkoutTarget && checkoutTarget.scrollIntoView) {
          checkoutTarget.scrollIntoView({behavior: "smooth", block: "start"})
        }
      })


    },

    focusPromoCode() {
      if (this.step !== 0) {
        return
      }

      if (!this.showPromoPanel) {
        this.openPromoCode()
      }

      this.$nextTick(() => {
        const purchasePanel = this.$refs['purchasePanel']

        if (purchasePanel && purchasePanel.scrollIntoView) {
          purchasePanel.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }

        const promoInput = this.$refs['promoInput']

        if (promoInput && promoInput.focus) {
          promoInput.focus({ preventScroll: true })
        }
      })
    },

    handleMobileAssistPrimary() {
      if (this.eventTickets.length !== 0) {
        this.startSale()
        return
      }

      this.focusPromoCode()
    },

    getLandingVisitorToken() {
      const storageKey = 'fomo_landing_visitor_token'
      const existing = window.localStorage.getItem(storageKey)
      if (existing) {
        return existing
      }

      const nextToken = `visit-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
      window.localStorage.setItem(storageKey, nextToken)
      return nextToken
    },

    recordLandingVisit() {
      if (!this.slug) {
        return
      }

      const normalizedCode = this.normalizePromoCodeValue(this.$route.query.co)
      const visitKey = `landing-visit:${this.slug}:${normalizedCode || 'direct'}:${new Date().toISOString().slice(0, 10)}`
      if (window.sessionStorage.getItem(visitKey)) {
        return
      }

      apiServiceSession(`/api/events/${this.slug}/landing-visit/`, 'POST', {
        visitor_token: this.getLandingVisitorToken(),
        code: normalizedCode,
        landing_path: window.location.pathname,
        referrer: document.referrer || '',
        user_agent: navigator.userAgent || '',
      }, { timeoutMs: 10000 }).then((data) => {
        if (!data || data.err) {
          return
        }

        window.sessionStorage.setItem(visitKey, '1')
      })
    },

    getEventTickets() {
      const requestVersion = ++this.ticketRequestVersion
      const requestedCode = this.normalizePromoCodeValue(this.$route.query.co)
      const requestedWanted = this.$route.query.wanted

      this.code = requestedCode
      this.promoCode = requestedCode || this.promoCode
      this.wanted = requestedWanted

      let endpoint = "/api/event-tickets/?event=" + this.id
      console.log(endpoint)

      if (requestedCode){
        endpoint = endpoint + "&code=" + requestedCode
      }

      if (this.host){
        endpoint = endpoint + "&host=" + this.host
      }

      if (this.next) {
        endpoint = this.next;
      }

      this.loadingQuestions = true;

      apiService(endpoint)
        .then(data => {
          if (requestVersion !== this.ticketRequestVersion) {
            return
          }

          const tickets = this.normalizeTicketsResponse(data)

          console.log(endpoint)
          this.eventTickets = tickets
          this.defaultEventTickets = requestedCode ? [] : [...tickets]
          this.errCode = Boolean(requestedCode) && tickets.length === 0

          if (requestedCode && tickets.length === 0) {
            this.showCode = true
          }

          this.showLoading = false;
          this.loadingEvent=false

          if (requestedWanted && tickets.length !== 0){
            this.startSale()
          }

          if (this.pixelId!=null){
            this.loadMetaPixel();
          }
        })
        .catch(() => {
          if (requestVersion !== this.ticketRequestVersion) {
            return
          }

          this.eventTickets = []
          this.defaultEventTickets = []
          this.errCode = Boolean(requestedCode)
          this.showLoading = false
          this.loadingEvent = false
        })

    },
   



    newEventTicketsSearch() {
      const requestVersion = ++this.ticketRequestVersion

      const promoCode = this.normalizePromoCodeValue(this.promoCode)

      if (!promoCode) {
        this.errCode = true
        return
      }

      this.promoCode = promoCode

      const endpoint = "/api/event-tickets/?event=" + this.id + "&code=" + promoCode

      this.loadingQuestions = true;
      this.promoLoading = true
      this.errCode = false

      apiService(endpoint)
        .then(data => {
          if (requestVersion !== this.ticketRequestVersion) {
            return
          }

          const tickets = this.normalizeTicketsResponse(data)

          console.log(endpoint)

          if (tickets.length === 0){
            this.errCode = true
            this.code = null
            this.showCode = true
            this.suppressPromoRouteWatcher = true
            this.syncPromoRoute('', false)
            this.eventTickets = [...this.defaultEventTickets]
          } else {
            this.errCode = false
            this.code = promoCode
            this.suppressPromoRouteWatcher = true
            this.syncPromoRoute(promoCode, this.wanted === 'true' || this.wanted === true)
            this.eventTickets = tickets
          }

          this.showLoading = false;
          this.promoLoading = false
        })
        .catch(() => {
          if (requestVersion !== this.ticketRequestVersion) {
            return
          }

          this.errCode = true
          this.code = null
          this.showCode = true
          this.suppressPromoRouteWatcher = true
          this.syncPromoRoute('', false)
          this.eventTickets = [...this.defaultEventTickets]
          this.promoLoading = false
          this.showLoading = false
        })
      
          
    },
   
    startUserCreation(products, subtotal, fee, total, map){
    console.log("muestro los productos")
  

    console.log(products)
    this.products=products
    console.log(this.products.length)
    this.order_total=Number.parseFloat(total) || 0
    this.order_base_total=Number.parseFloat(total) || 0
    this.order_fee=Number.parseFloat(fee) || 0
    this.order_subtotal=Number.parseFloat(subtotal) || 0
    this.order_addons_total=0
    this.selectedAddons=[]


    if (this.event.quick_checkout_enabled){
      const quickTickets = this.buildTicketsTableFromProducts(this.products)
      if (this.ticketsRequireGuestDetails(quickTickets)) {
        this.step = 2
      } else {
        this.customer=1
        this.ticketsTable=quickTickets
        this.step=this.hasEligibleFomoSafeTickets(this.ticketsTable) ? 6 : 3
      }
    }else{ //caja


      if (map>0){
      for (let index = 0; index < this.products.length; index++) {
        console.log("muestro  el produ")

        console.log(this.products[index])

  
      if (this.products[index].map==true && this.products[index].quantity!=0){

            this.seatsProducts.push(this.products[index])
      

      }

      this.mapLenght=this.seatsProducts.length

      this.map=true
      this.step=5

    }
    this.products = this.products.filter(product => product.map == false);// saco array

    
    }else{
      this.step++

    }

  }



  },


  startUserCreation1(selectedIds){
    console.log("ok ok ok")
    console.log(selectedIds)
    this.selectedSeats= this.selectedSeats.concat(selectedIds)
    if ((this.mapValidator+1)==this.mapLenght){
    this.map=false
    this.step=2

  }
  this.mapValidator++

  
},


  startGuestNames(name, last_name, phone, email, cc){
    this.name=name
    this.last_name=last_name
    this.phone=phone
    this.email=email
    this.cc=cc
    this.step++
  },


  startFinalSale(guests, id){
    this.ticketsTable=guests.map((ticket) => ({
      ...ticket,
      access_code_snapshot: this.code || '',
    }))

    this.customer=id

    if ((Number.parseFloat(this.order_base_total) || 0) <= 0) {
      this.selectedAddons=[]
      this.order_addons_total=0
      this.order_total=this.order_base_total
      this.step=3
      return
    }

    this.step=this.hasEligibleFomoSafeTickets(this.ticketsTable) ? 6 : 3
  },

  startPaymentStep(addons, addonsTotal){
    this.selectedAddons=addons
    this.order_addons_total=Number.parseFloat(addonsTotal) || 0
    this.order_total=this.order_base_total + this.order_addons_total
    this.step=3
  },

  completeSale(number, tck){

      console.log("lleue")

      let  conts = []

        
       
       if (this.pixelId ) {
        
      for (let index = 0; index < this.products.length; index++) {
        let cont = {id: this.products[index].id, quantity: 1, item_price: this.products[index].amount}

        conts.push(cont)
      
      }
      
      window.fbq('track', 'Purchase', {
          value: this.subtotal,
          currency: 'USD',
          contents: conts,
          content_type: 'product'
        });
      }
    
  
    
           
      if (number==2  ){
          const pendingQuery = {}
          if (tck && typeof tck === 'object') {
            if (tck.provider) pendingQuery.provider = tck.provider
            if (tck.invoiceId) pendingQuery.invoice = tck.invoiceId
            if (tck.paymentIntentId) pendingQuery.payment_intent = tck.paymentIntentId
            if (tck.status) pendingQuery.status = tck.status
          }
          this.$router.push({ name: "pending-confirmation", params: { id: this.event.slug }, query: pendingQuery });
        }else{

          
          this.$router.push({ name: "confirmation", params: { id: this.event.slug}, query: { co: tck } });
        }
    
  },






          


    formatDate(dateString){
        const objectDate  = new Date(dateString);
        
        const year = objectDate.getFullYear();

const month = String(objectDate.getMonth() + 1).padStart(2, '0');

const day = String(objectDate.getDate()).padStart(2, '0');


        let format = day + "." + month + "." + year
              // Then specify how you want your dates to be formatted
         return format;
    },

    hasEligibleFomoSafeTickets(tickets) {
      if (!this.event.fomo_safe_enabled || !Array.isArray(tickets)) {
        return false
      }

      return tickets.some((ticket) => (Number.parseFloat(ticket.amount) || 0) > 0)
    },

    ticketsRequireGuestDetails(tickets) {
      if (!Array.isArray(tickets)) {
        return false
      }

      return tickets.some((ticket) => Array.isArray(ticket.guest_fields) && ticket.guest_fields.length > 0)
    },

    buildTicketsTableFromProducts(products) {
      const expandedTickets = []

      for (let i = 0; i < products.length; i += 1) {
        const product = products[i]
        const quantity = Number.parseInt(product.quantity, 10) || 0
        const quantityFactor = Number.parseInt(product.quantity_factor, 10) || 1

        for (let index = 0; index < quantity; index += 1) {
          for (let factor = 0; factor < quantityFactor; factor += 1) {
            expandedTickets.push({
              quantity: 1,
              amount: product.amount,
              product: product.id,
              name: product.name,
              is_courtesy: product.is_courtesy,
              first_name: '',
              last_name: '',
              payment_term: 1,
              extra_answers: {},
              guest_fields: Array.isArray(product.guest_fields) ? product.guest_fields : [],
              ig: '',
              age: '',
              cc: '',
              size: '',
              gender: 0,
              entry: '',
              seat: '',
              seat_name: '',
              seat_assigned: false,
              access_code_snapshot: this.code || '',
            })
          }
        }
      }

      return expandedTickets
    },




    validateProc(){
      let format = false

      if(this.loadingEvent && !this.wanted){  

        format = false

      }else if (this.loadingEvent && this.wanted){
        format = true
      }else if (!this.loadingEvent && !this.wanted){
 
        format = true

      }else if(!this.loadingEvent && this.wanted){

        format = true
      }



         return format;
    },







  },
 

};
</script>

<style>


.vanilla-zoom {
  width: 100%;
}

.vanilla-zoom .sidebar {
  width: 100%;
  display: flex;
}

.vanilla-zoom .sidebar img.small-preview {
  width: 60px;
  margin-right: 5px;
  cursor: pointer;
  opacity: .5;
}

.vanilla-zoom .sidebar img.small-preview.active, .vanilla-zoom .sidebar img.small-preview:hover {
  opacity: 1;
}

.vanilla-zoom .sidebar img.small-preview:last-child {
  margin-right: 0;
}

.vanilla-zoom .zoomed-images {
  width: 100%;
  height: 300px;
  flex: 1;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
  margin-bottom: 5px;
}


.vanilla-zoom .container-phpto {
  width: 100%;
  height: 300px;
  flex: 1;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
  margin-bottom: 5px;
}




*, *::before, *::after {
  box-sizing: border-box;
}

.clean-block.clean-product .product-info .info .summary {
  border-top: 1px solid white;
  padding-top: 30px;
}

.clean-block.clean-product .gallery {
  padding: 16px;
  background:
    radial-gradient(circle at top left, rgba(210, 219, 236, 0.08), transparent 18%),
    radial-gradient(circle at 82% 14%, rgba(56, 64, 92, 0.22), transparent 28%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.008)),
    rgba(4, 6, 12, 0.96);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.28);
  border-radius: 28px;
  border: 1px solid rgba(198, 208, 230, 0.12);
}


 .searchcode{
       display: flex;
       flex-wrap: wrap;
       gap: 12px;
       width: 100%;
       box-shadow: none;
       }
   
       .searchcode .fa-search{

        position: absolute;
        top: 15px;
        left: 16px;

       }

       .searchcode button{
        position: static;
        height: auto;
        width: auto;
        text-align: center;
        vertical-align: middle;
       }

       
.searchcode .form-control {
  background: transparent;
  border: none;
  border-radius: 18px;
  box-shadow: none;
  outline: none;
  color: #eef3ff;
  text-indent: 0;
  height: 54px;
}


    
</style>
